export default "__VITE_ASSET__CjbZsx1V__"